// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b6f852e43714b502b88d709ae90ee05fa9588d85.chunk.bundle.js";
};